/**
 * Empty cart drawer "Recommended for you" carousel.
 * Scroll-snap track with prev/next arrows and a "current/total" counter.
 * Markup: snippets/cart-drawer-recommendations.liquid
 */
class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.current = this.querySelector('[data-current]');
    this.prev = this.querySelector('[data-direction="prev"]');
    this.next = this.querySelector('[data-direction="next"]');
    if (!this.track) return;

    this.prev?.addEventListener('click', this.#onPrev);
    this.next?.addEventListener('click', this.#onNext);
    this.track.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.prev?.removeEventListener('click', this.#onPrev);
    this.next?.removeEventListener('click', this.#onNext);
    this.track?.removeEventListener('scroll', this.#onScroll);
  }

  get #count() {
    return this.track.children.length;
  }

  get #index() {
    const width = this.track.clientWidth || 1;
    // scrollLeft is negative in RTL
    return Math.round(Math.abs(this.track.scrollLeft) / width);
  }

  #goTo(index) {
    const target = Math.max(0, Math.min(index, this.#count - 1));
    const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    this.track.scrollTo({ left: target * this.track.clientWidth * direction });
  }

  #onPrev = () => this.#goTo(this.#index - 1);

  #onNext = () => this.#goTo(this.#index + 1);

  #onScroll = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.#update());
  };

  #update() {
    const index = this.#index;
    if (this.current) this.current.textContent = String(index + 1);
    if (this.prev) this.prev.disabled = index <= 0;
    if (this.next) this.next.disabled = index >= this.#count - 1;
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}
